// extracted by mini-css-extract-plugin
export default {"selectBox":"select_selectBox__6DUhJ","solid":"select_solid__HlpHX","outline":"select_outline__xexBI","arrow":"select_arrow__Tt0pE"};